module.exports = __webpack_public_path__ + "static/media/carroussel_3.3d145d69.png";